import { render, staticRenderFns } from "./VueSelectMultiSize.vue?vue&type=template&id=2367285c&"
import script from "./VueSelectMultiSize.vue?vue&type=script&lang=js&"
export * from "./VueSelectMultiSize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports